import React from "react";
import {
  Accordion,
  DoubleContent,
  SectionContent,
  Text,
} from "../../../../components";
import { dfi } from "../../data";

const leftAccordionList = [
  {
    title: "Morte ou invalidez permanente (MIP)",
    body: (
      <>
        <Text>
          A cobertura MIP é pra deixar você e sua família bem cuidada. Caso
          ocorra um imprevisto (morte ou invalidez permanente) e você não
          consiga arcar com o financiamento, o seguro quita ou amortiza parte
          dele, caso exista mais de um participante no contrato de
          financiamento.
        </Text>
        <Text>
          <li>
            Morte: Em caso de falecimento, nós quitamos o seu financiamento ou
            parte dele, caso exista mais de um participante no contrato de
            financiamento. Em caso de morte por doença, só haverá cobertura caso
            você tenha declarado doenças pré-existente no momento da contratação
            do financiamento ou adquirido a doença após a contratação.
          </li>
          <li>
            Invalidez permanente: Em caso de acidente que resulte em invalidez
            total ou permanente para a sua principal atividade laborativa, nós
            quitamos o seu financiamento ou parte dele, caso exista mais de um
            participante no contrato de financiamento. Só haverá cobertura por
            invalidez em caso de doença, caso você tenha declarado doenças
            pré-existentes no momento da contratação do financiamento ou
            adquirido a doença após a contratação.
          </li>
        </Text>
      </>
    ),
  },
];

const rightAccordionList = [dfi];

const CoberturasSeguroFgtsSpbe = () => {
  return (
    <>
      <SectionContent>
        <DoubleContent
          leftContent={<Accordion listItems={leftAccordionList} />}
          rightContent={<Accordion listItems={rightAccordionList} />}
        />
      </SectionContent>
    </>
  );
};

export default CoberturasSeguroFgtsSpbe;
